import { Step } from '~components/wizard-form/props';

import Confirm from '~direct-debits/components/payment-batches-wizard/Confirm';
import Filters from '~direct-debits/components/payment-batches-wizard/Filters';
import { PaymentBatchPreviewResponse } from '~direct-debits/models';

// Shared form state for both steps. `preview` and `acknowledged` are isAttribute:
// false — they exist purely to drive showNextButton gating and step-2 rendering,
// not to be sent to the API.
export interface PaymentBatchesWizardValues {
  due_date_cutoff?: string;
  description?: string;
  preview?: PaymentBatchPreviewResponse;
  acknowledged?: boolean;
}

const steps: Step[] = [
  {
    step: 1,
    title: 'Configure Filters',
    fields: {
      due_date_cutoff: {
        type: 'date',
        caption: 'Include invoices due on or before',
        description: 'Optional. Leave blank to include every eligible unpaid invoice regardless of due date.',
        colSize: 6,
      },
      filters_preview: {
        type: 'custom',
        caption: 'Preview',
        component: Filters,
        colSize: 12,
        // Re-render Filters whenever the cutoff changes so the live count updates.
        dependencies: ['due_date_cutoff'],
        isAttribute: false,
      },
    },
    // Disabled until the live preview reports at least one eligible invoice. The
    // submit endpoint would otherwise 400 with NoEligibleInvoicesError.
    showNextButton: ({ values }: { values: PaymentBatchesWizardValues }) =>
      (values?.preview?.stats?.invoice_count ?? 0) > 0,
    nextButtonCaption: 'Next: Review Batch',
  },
  {
    step: 2,
    title: 'Preview & Confirm',
    fields: {
      description: {
        type: 'text',
        caption: 'Batch description (optional)',
        colSize: 12,
      },
      confirmation: {
        type: 'custom',
        caption: 'Confirm',
        component: Confirm,
        colSize: 12,
        // Confirm reads `preview` (set by Filters in step 1) and writes
        // `acknowledged` (the irreversible-action checkbox). The Fields
        // component slices `value` to ONLY the keys listed here, so omitting
        // either field would prevent the component from seeing it.
        dependencies: ['preview', 'acknowledged'],
        isAttribute: false,
      },
    },
    // Submit gated on the irreversible-action checkbox per AC.
    showNextButton: ({ values }: { values: PaymentBatchesWizardValues }) => values?.acknowledged === true,
  },
];

export default steps;
